import { api } from "../base";
import type { IBookLayerSeries } from "@pulse-ui/codegen-v2/generated_ts/market_data";

export type {
  IBookLayerFill,
  IBookLayerPoint,
  IBookLayerSeries,
} from "@pulse-ui/codegen-v2/generated_ts/market_data";

// Served by trading-ops-server GET /api/trading-ops/v1/book-layer-series, which reads the
// pre-computed per-hour ladders l2-snapshot-store writes to S3 - both the venue books and
// Polaris's own CLST book, which only exists in this form. Times are RFC3339 or epoch millis.
export interface GetBookLayerSeriesParams {
  symbol: string;
  start_time: string;
  end_time: string;
  /**
   * Comma-separated quote-notional targets to keep, e.g. `10000,25000`; all when absent.
   * Narrowing this is what keeps a response small - a full grid is ten fills per side per point.
   * The response still reports the whole stored `grid`, so one narrow request is enough to learn
   * which targets a symbol actually has.
   */
  layers?: string;
}

const bookLayerSeriesEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getBookLayerSeries: build.query<IBookLayerSeries, GetBookLayerSeriesParams>({
      query: (params) => ({
        url: "/api/trading-ops/v1/book-layer-series",
        params,
      }),
    }),
  }),
});

export const {
  useGetBookLayerSeriesQuery,
  useLazyGetBookLayerSeriesQuery,
} = bookLayerSeriesEndpoints;
